import React, { Component } from "react";
import { Route } from "react-router";
import * as R from "ramda";

import client from "../api/apollo";
import { deleteAuthObject } from "../localStorage";
import RedirectWithSearch from "./RedirectWithSearch";
import WithAuth from "./WithAuth";

class RenderedComponent extends Component {
    constructor(props) {
        super(props);

        this.preventRender = false;

        const {
            layoutType = "blank",
            oldLayoutType,
            changeLayoutType = () => {},
        } = this.props;

        if (oldLayoutType) {
            this.preventRender = oldLayoutType !== layoutType;
            if (this.preventRender) {
                changeLayoutType(layoutType);
            }
        }
    }

    render() {
        const {
            component: Component,
            render: Render,
            isAuthenticated = false,
            redirectUnauthenticated = true,
            auth = {},
        } = this.props;

        if (isAuthenticated) {
            if (auth.requires_2fa_setup) {
                // NOTE: hack for redirecting to setup steps
                // In the future we should do this in React
                client.resetStore();
                deleteAuthObject();
                // TODO: remove when issue will be fixed https://github.com/apollographql/apollo-cache-persist/issues/126
                localStorage.removeItem("apollo-cache-persist");
                window.location.pathname = "/account/two_factor/setup";
                return null;
            }
            if (this.preventRender) {
                return null;
            }
            return Render ? Render(this.props) : <Component {...this.props} />;
        }

        if (!redirectUnauthenticated) {
            return null;
        }

        if (window.COGNITO_ENABLED === "True") {
            window.location.pathname = "/cognito/";
            return null;
        }

        return (
            <RedirectWithSearch
                to={{
                    pathname: "/login/",
                    state: {
                        from: this.props.location,
                    },
                }}
            />
        );
    }
}

const PrivateRoute = props => {
    const additionalProps = R.omit(
        [
            "component",
            "render",
            "isAuthenticated",
            "redirectUnauthenticated",
            "auth",
        ],
        props
    );

    return (
        <Route
            {...additionalProps}
            component={routerProps => (
                <RenderedComponent {...props} {...routerProps} />
            )}
        />
    );
};

export default WithAuth(PrivateRoute);
